export default __webpack_public_path__ + "static/media/search-icon.f2ae72f0.svg";